
import React, { useState } from "react";
import { fetchData } from "../../networkRequests";
import {
  Button,
  Input
} from "reactstrap";
import LoadingArrow from "../../../../images/login/spinner-min.gif";
import { getCookie, reversibleHash } from "../../../oro-module/commonFunctions";


const LoggingInGIF = () => {
  return <div style={{ textAlign: "center", marginTop: 20 }}><img width="50" src={LoadingArrow} /></div>
}


export const LoginButton = ({ handleLogin, isLoggingIn, logo_url }) => {

  return (
    <span>
      {!isLoggingIn &&
        <Button
          className="col-sm-12 btn login-btn text-black btn-success btn-md "
          style={{ textAlign: "center", marginTop: 20 }}
          onClick={handleLogin}
        >
          Log In
        </Button>
      }
      {isLoggingIn &&
        <LoggingInGIF />
      }
    </span>
  )
}